module.exports = __webpack_public_path__ + "img/4.213eaa50.png";